import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            热度榜
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门电视剧排行
          </h2>
          <p className="text-sm text-foreground-500 mt-2">实时热度数据，发现大家都在追的好剧</p>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={item.title}
              href="#ranking"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-100' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <div className="flex items-center gap-1 text-sm font-semibold text-foreground-700 flex-shrink-0">
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-fill text-accent-500 text-sm" />
                ) : item.trend === 'down' ? (
                  <i className="ri-arrow-down-fill text-foreground-400 text-sm" />
                ) : (
                  <span className="w-3.5" />
                )}
                {item.hot}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}